module.exports = __webpack_public_path__ + "static/media/location.c93ff43d.svg";